<template>
  <modal back="edit-upload" :title="$t('customization.upload')">
    <upload-list @select-upload="closeModalAfter(() => selectUpload($event))" />
  </modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
import UploadList from './UploadList';
import ActiveElement from '@/mixins/activeElement';
import Redirect from '@/mixins/redirect';

export default {
  name: 'UploadDesignEdit',
  components: {
    UploadList,
    Modal
  },
  mixins: [ActiveElement, Redirect],
  methods: {
    selectUpload(upload) {
      this.updateElement({
        srcFile: upload.srcFile
      });
    }
  }
};
</script>
